module.exports = __webpack_public_path__ + "img/nuts.a96a016e.png";